import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import withAuthorization from '../higherOrder/withAuthorization'

import { INTRO_QUESTIONS } from '../../constants/routes'
import { getIntroQuestionsState } from '../../actions'
import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import { LoadingWrapper } from '../StyledComponents/Classifier/LoadingScreen'
import { FillerDiv } from '../StyledComponents/Fillers'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper } from '../StyledComponents/IntroQuestions/Question'
import Option from '../IntroQuestions/Option'

class MailVerification extends Component {
    constructor(props) {
        super(props)

        this.sendVerification = this.sendVerification.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const { sessionState } = nextProps
        if (!!sessionState.authUser && !!sessionState.authUser.emailVerified) {
            this.props.history.push(INTRO_QUESTIONS)
        }
    }

    sendVerification() {
        const { sessionState } = this.props

        if (sessionState.authUser) {
            sessionState.authUser.sendEmailVerification()
        }
    }

    render() {
        const { sessionState } = this.props
        if (!sessionState.authUser) {
            return (
                <LoadingWrapper>
                    <ThreeBounceSpinner />
                </LoadingWrapper>
            )
        }

        const text = 'Wir kümmern uns um die Sicherheit deiner Daten. Daher musst du deine Email Adresse bestätigen... Du erhältst gleich eine Mail mit einem Bestätigungslink. Sobald du den Link bestätigt hast, sollte alles funktionieren.'

        return (
            <FillerDiv>
                <QuestionWrapper>
                    <QuestionText fontSize="1.4rem">
                        <QuestionTextSpan>
                            Willkommen! <br /><br />
                            {text}
                        </QuestionTextSpan>
                    </QuestionText>
                    <OptionsWrapper>
                        <Option
                            data={{ label: 'Mail erneut senden' }}
                            fullWidth
                            onOptionClicked={this.sendVerification}
                        />
                        <Option
                            data={{ label: 'Seite neu laden' }}
                            fullWidth
                            onOptionClicked={() => window.location.reload()}
                        />
                    </OptionsWrapper>
                </QuestionWrapper>
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    sessionState: state.sessionState,
})

export default compose(
    withAuthorization(authCondition),
    withRouter,
    connect(mapStateToProps, {
        getIntroQuestionsState,
    })
)(MailVerification)



// WEBPACK FOOTER //
// ./src/components/pages/MailVerification.js